import clsx from 'clsx'

export default function TOCLink({id, level, minLevel, text, activeSection, onTOCClick}) {
    const handleClick = (e) => {
        e.preventDefault();
        
        // Call the programmatic scroll handler if provided
        if (onTOCClick) {
            onTOCClick(id);
        }
        
        // Smooth scroll to the target element
        const targetElement = document.getElementById(id);
        if (targetElement) {
            targetElement.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <button
            id={`link-${id}`}
            onClick={handleClick}
            className={clsx(
                'hover:text-gray-700 dark:hover:text-gray-200',
                'text-left w-full bg-transparent border-none cursor-pointer transition-all duration-200',
                activeSection === id
                    ? 'font-semibold text-green-100'
                    : 'text-brown-100'
            )}
            style={{ marginLeft: (level - minLevel) * 16 }}
        >
            {text}
        </button>
    );
}
